// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.inv_item_origin_enum */
var InvItemOriginEnum;
(function (InvItemOriginEnum) {
    InvItemOriginEnum["PURCHASED"] = "PURCHASED";
    InvItemOriginEnum["PRODUCED"] = "PRODUCED";
})(InvItemOriginEnum || (InvItemOriginEnum = {}));
;
export default InvItemOriginEnum;
/** Zod schema for inv_item_origin_enum */
export const invItemOriginEnum = z.nativeEnum(InvItemOriginEnum);
//# sourceMappingURL=InvItemOriginEnum.js.map